<div class="wrapperi">
    <div class="top-banner mt-4 ps-3 pe-3">
        <div class="col-12 row m-0 h-100">
            <div class="col-12 bg-cover relative  d-flex align-items-center padding-top-banner">
                <div class="col-12 row m-0">
                    <div class="col-6 d-flex flex-column justify-content-center">
                        <div class=" ">
                            <p class="banner-title-text">Hallitse hakuvahtejasi</p>
                            <p class="banner-subtitle-text f-os">Haluatko saada ilmoituksen aina teille sopivista profiileista? Hakuvahteja luomalla se onnistuu. Niitä voit luoda niin monta kuin haluat. </p>

                        </div>
                    </div>
                    <div class="col-6 justify-content-end d-flex">

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 ps-2 pe-2 pb-4 pt-0">
        <div class="ps-2 pt-3">
            <p class="semiboldtextblue90024 mb-1">Sinun hakuvahtisi <span
                    class="semiboldtextblue50024 ms-2">{{alerts.length}}</span></p>
        </div>
        <div class="" *ngIf="alerts && alerts.length > 0; else no_lists">
            <div class="row m-0 p-0">
                <div class="col-md-6 col-lg-6 col-xl-6 ps-1 mt-3" routerLink="/{{businessID}}/search-alerts/search-alert/{{data._id}}" *ngFor="let data of alerts">
                    <div class="" *ngIf="true;else banner_template">
                        <div class="formed-border-radius relative card-body formed-shadow formed-shadow p-20 bg-w">
                            <div class="d-flex justify-content-between top-cont pb-3">
                                <div class="text-container d-flex">
                                    <img src="../../assets/icons/search_icon.svg" width="14" class="me-2" alt="">
                                    <p class="semiboldtextblue90020 mb-0">{{data.name}}</p>

                                </div>
                                <div class="new-container">

                                </div>

                            </div>
                            <div class="icons-container d-inline-flex mt-15 mb-15">
                                <div class="">
                                    <div class="locations-container d-flex" *ngIf="data.areas.length > 0">
                                        <div class=" d-flex align-items-center">
                                            <!-- Icon Section -->
                                            <div class="icon-container d-flex align-items-center me-2">
                                                <img src="../../assets/icons/location_dark_blue.svg" alt="Icon">
                                            </div>

                                            <!-- Skills and +X Section -->
                                            <div
                                                class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                <!-- Skills List -->
                                                <div class="skills-container">
                                                    <span class="normaltextblue80016 me-1 f-os"
                                                        *ngFor="let area of data.areas; let i = index">
                                                        <span *ngIf="i < 1">
                                                            {{ area.name_fi }}<span *ngIf="i < 1"></span>
                                                        </span>
                                                    </span>
                                                </div>

                                                <!-- +X Section -->
                                                <div class="ms-2 badge-container">
                                                    <span class="text-end skill-num-tag normaltextblue60016 me-2"
                                                        *ngIf="data.areas.length > 1">
                                                        +{{ data.areas.length - 1 }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="skills-container" *ngIf="data.skills.length > 0">
                                        <div class=" d-flex align-items-center">
                                            <!-- Icon Section -->
                                            <div class="icon-container d-flex align-items-center me-3">
                                                <img src="../../assets/icons/skills_icon.svg" alt="Icon">
                                            </div>

                                            <!-- Skills and +X Section -->
                                            <div
                                                class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                <!-- Skills List -->
                                                <div class="skills-container">
                                                    <span class="normaltextblue80016 me-1 f-os"
                                                        *ngFor="let skill of data.skills; let i = index">
                                                        <span *ngIf="i < 1">
                                                            {{ skill.name_fi }}<span *ngIf="i < 1"></span>
                                                        </span>
                                                    </span>
                                                </div>

                                                <!-- +X Section -->
                                                <div class="ms-2 badge-container">
                                                    <span class="text-end skill-num-tag normaltextblue60016 me-3"
                                                        *ngIf="data.skills.length > 1">
                                                        +{{ data.skills.length - 1 }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="jobtitles-container" *ngIf="data.jobTitles.length > 0">
                                        <div class=" d-flex align-items-center">
                                            <!-- Icon Section -->
                                            <div class="icon-container d-flex align-items-center me-2">
                                                <img src="../../assets/icons/suitcase_icon.svg" alt="Icon">
                                            </div>

                                            <!-- Skills and +X Section -->
                                            <div
                                                class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                <!-- Skills List -->
                                                <div class="skills-container">
                                                    <span class="normaltextblue80016 me-1 f-os"
                                                        *ngFor="let jobtitle of data.jobTitles; let i = index">
                                                        <span *ngIf="i < 1">
                                                            {{ jobtitle.name_fi }}<span *ngIf="i < 1"></span>
                                                        </span>
                                                    </span>
                                                </div>

                                                <!-- +X Section -->
                                                <div class="ms-2 badge-container">
                                                    <span class="text-end skill-num-tag normaltextblue60016 me-3"
                                                        *ngIf="data.jobTitles.length > 1">
                                                        +{{ data.jobTitles.length - 1 }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="matches-container">
                                    <p class="semiboldtextblue90020 mb-1">Osumia: <span>{{data.profiles.length}}</span></p>
                                    <div class="d-flex align-items-center" *ngIf="data.profiles.length > 0;else no_matches">
                                        <!-- Loop through profiles and show up to 4 profile images -->
                                        <ng-container *ngFor="let profile of data.profiles.slice(0, 4); let i = index">
                                          <img
                                            [src]="profile.userData.profilePicture != null || profile.userData.profilePicture != ''? profile.userData.profilePicture : '../../assets/icons/formed_no_profile.svg'"
                                            class="rounded-circle border-image border-light"
                                            [ngClass]="i >= 1?'image-group-margin':''"
                                            onerror="this.src='../../assets/icons/formed_no_profile.svg'"
                                            width="45"
                                            height="45"
                                          />
                                        </ng-container>
                                      
                                        <!-- Show "+X" if there are more profiles -->
                                        <div
                                          *ngIf="data.profiles.length > 5"
                                          class="d-flex justify-content-center align-items-center image-plus rounded-circle"
                                          style="width: 42px; height: 42px;"
                                        >
                                          +{{ data.profiles.length - 5 }}
                                        </div>
                                      </div>
                                      <ng-template #no_matches>
                                        <div class="" style="height: 45px;"></div>
                                      </ng-template>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ng-template #no_lists>
            <div class=" mt-4 ps-2 pe-2">
                <div class="bg-f-w formed-shadow col-12 row pb-4 mb-4 m-0" *ngIf="!isLoading">
                    <div class="col-2">

                    </div>
                    <div class="col-12 col-lg-8">
                        <div class="bg-f-w p-4">
                            <div class="justify-content-center d-flex">
                                <img src="../../assets/images/no_search_found.png" height="270" alt="">
                            </div>
                            <div class="p-4">
                                <p class="semiboldtextblue24 text-center mt-4">
                                    Ei hakuvahteja
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-2">

                    </div>
                </div>
            </div>


        </ng-template>
    </div>




